import React from 'react';
import { FlexStartRow } from '../common/forms/FormElements';
import './AssignmentCalendar.scss';
import CommonContext from '../Common';

export class AssignmentEvent extends React.Component {
    static contextType = CommonContext;

    render() {
        if (!(this.context ?? {}).user) {
            return null;
        }

        const { event } = this.props;

        const jobTitle = `${event.jobTitle}${
            event.subcontractorName ? ` - ${event.subcontractorName}` : ''
        }`;

        return (
            <FlexStartRow>
                <span>{event.title}</span>
                <span className="ml-1 event-job-title">{` - ${jobTitle}`}</span>
            </FlexStartRow>
        );
    }
}
